<template>
  <div>
    <b-modal
      id="modal-add-link"
      centered
      :title="title"
      size="lg"
      :hide-footer="true"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <div>
          <div>
            <b-form
              ref="form"
              :style="{ height: trHeight }"
              class="repeater-form"
              @submit.prevent="handleSubmit(Link)"
              @reset.prevent="resetForm"
            >
              <b-form-group>
                <b-button
                  variant="success"
                  class="add-btn"
                  @click="repeateAgain"
                >
                  <feather-icon icon="PlusIcon" class="mr-25" />
                  <span>Web Link</span>
                </b-button>
                <drive-picker
                  v-if="googleConfig.clientId && isPickerLoaded"
                  ref="googlePicker"
                  :client-id="googleConfig.clientId"
                  :api-key="googleConfig.apiKey"
                  :developer-key="googleConfig.apiKey"
                  :app-id="googleConfig.projectId"
                  :oauth-token="googleToken"
                  scope="https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/userinfo.email openid"
                  @picker-picked="onDriveFilePicked"
                  @picker-oauth-response="onAuthenticated"
                  @picker-oauth-error="onAuthError"
                >
                  <drive-picker-docs-view view-id="DOCS"></drive-picker-docs-view>
                </drive-picker>
                <!-- Multi-Account Dropdown (Only shows if there are valid saved accounts) -->
                <b-dropdown
                  v-if="validAccounts && validAccounts.length > 0"
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  v-b-tooltip.hover.top="currentEmail"
                  variant="outline-secondary"
                  split
                  class="btn-google-drive"
                  boundary="window"
                  @click="openPicker"
                >
                  <template #button-content>
                    <div class="d-flex align-items-center">
                      <b-img
                        :src="DriveIcon"
                        alt="logo"
                        height="18"
                        width="18"
                        class="mr-50"
                      />
                      <span>{{ buttonText }}</span>
                    </div>
                  </template>

                  <b-dropdown-header class="py-50 px-1 font-weight-bolder">
                    Accounts
                  </b-dropdown-header>
                  <b-dropdown-item
                    v-for="acc in validAccounts"
                    :key="acc.email"
                    :active="acc.email === currentEmail"
                    @click="selectAccount(acc)"
                  >
                    <div class="d-flex align-items-center justify-content-between">
                      <span>{{ acc.email }}</span>
                      <feather-icon
                        v-if="acc.email === currentEmail"
                        icon="CheckIcon"
                        size="14"
                        class="text-success ml-50"
                      />
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-divider />
                  <b-dropdown-item @click="addNewAccount">
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-50"
                    />
                    <span>Add New Account</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="clearAllAccounts">
                    <feather-icon
                      icon="Trash2Icon"
                      class="mr-50"
                    />
                    <span class="text-danger">Clear All</span>
                  </b-dropdown-item>
                </b-dropdown>

                <!-- Regular Button (When not authed) -->
                <b-button
                  v-else
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  class="btn-google-drive"
                  @click="openPicker"
                >
                  <div class="d-flex align-items-center">
                    <b-img
                      :src="DriveIcon"
                      alt="logo"
                      height="18"
                      width="18"
                      class="mr-50"
                    />
                    <span>Google Drive</span>
                  </div>
                </b-button>
              </b-form-group>
              <!-- Row Loop -->
              <b-row
                v-for="(l, index) in links"
                :id="l.id"
                :key="l.id"
                ref="row"
                eslint-disable-next-line
                vue
                no-use-v-if-with-v-for
              >
                <!-- Item Name -->
                <b-col>
                  <!-- Name -->
                  <validation-provider
                    #default="validationContext"
                    name="url"
                    rules="url|required"
                  >
                    <h6>Link</h6>
                    <b-form-group>
                      <b-form-input
                        id="url"
                        v-model="l.value"
                        type="text"
                        :state="getValidationState(validationContext)"
                        placeholder="Enter webpage link"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Cost -->
                <b-col>
                  <!-- Column Select -->
                  <validation-provider
                    #default="validationContext"
                    name="Title"
                    rules="required"
                  >
                    <h6>Title</h6>
                    <b-form-group>
                      <b-form-input
                        id="matrix-1"
                        v-model="l.name"
                        :state="getValidationState(validationContext)"
                        placeholder="Enter webpage title"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="auto">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                  >
                    <feather-icon
                      icon="XIcon"
                      class="mr-25"
                    />
                    <span>Delete</span>
                  </b-button>
                </b-col>
              </b-row>
              <!-- Form Actions -->
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  type="submit"
                  @click="handleSubmit()"
                >
                  Save
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  variant="outline-secondary"
                  @click="hideAddLinkModal()"
                >
                  Cancel
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
  import {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BImg,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    VBTooltip,
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { $themeConfig } from '@themeConfig'
  import Ripple from 'vue-ripple-directive'
  import { heightTransition } from '@core/mixins/ui/transition'
  import DriveIcon from '@/assets/images/icons/drive.png'

  export default {
    components: {
      BModal,
      BFormInput,
      BForm,
      BFormGroup,
      BButton,
      BFormInvalidFeedback,
      BRow,
      BCol,
      BImg,
      BDropdown,
      BDropdownItem,
      BDropdownDivider,

      // Form Validation
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      Ripple,
      'b-tooltip': VBTooltip,
    },
    mixins: [heightTransition],
    props: {
      entity: {
        required: true,
        type: String,
      },
      title: {
        required: true,
        type: String,
      },
      docs: {
        type: Array,
        default: () => [],
      },
      link: { type: Function, default: () => '' },
    },
    data() {
      const { DropBoxIcon, GoogleIcon } = $themeConfig.icons
      return {
        links: [],
        nextTodoId: 1,
        isPickerLoaded: false,
        googleAccounts: JSON.parse(localStorage.getItem('google_accounts') || '[]'),
        googleToken: localStorage.getItem('google_drive_token') || null,
        currentEmail: localStorage.getItem('google_active_email') || null,
        expiresAt: localStorage.getItem('google_token_expires_at') || null,
        DropBoxIcon,
        DriveIcon,
        googleConfig: {
          apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
          clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          projectId: process.env.VUE_APP_GOOGLE_PROJECT_ID,
        },
      }
    },
    mounted() {
    },
    watch: {
      docs() {
        this.links = []
        if (this.docs && this.docs.length !== 0) {
          const lastId = this.docs[this.docs.length - 1].id
          this.nextTodoId = typeof lastId === 'number' ? lastId + 1 : this.nextTodoId
        }
      },
    },
    computed: {
      validAccounts() {
        return this.googleAccounts.filter(acc => !this.isTokenExpired(acc))
      },
      buttonText() {
        if (!this.currentEmail || this.isTokenExpired()) {
          return 'Google Drive'
        }
        
        const email = this.currentEmail
        if (email.length > 20) {
          const parts = email.split('@')
          if (parts.length === 2) {
            const name = parts[0]
            const domain = parts[1]
            if (name.length > 8) {
              return `Google Drive: ${name.substring(0, 5)}...@${domain}`
            }
          }
          return `Google Drive: ${email.substring(0, 15)}...`
        }
        return `Google Drive: ${email}`
      },
    },
    methods: {
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      repeateAgain() {
        this.links.push({
          id: (this.nextTodoId += 1),
        })
      },
      removeItem(index) {
        this.links.splice(index, 1)
      },
      hideAddLinkModal() {
        this.resetForm()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-add-link')
        })
      },
      Link() {
        this.hideAddLinkModal()
        const formattedLinks = this.links.map(l => ({
          ...l,
          value: l.value ? (l.value.trim().match(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//i) ? l.value.trim() : `https://${l.value.trim()}`) : l.value
        }))
        this.link(formattedLinks)
      },
      resetForm() {
        this.$nextTick(() => {
          this.$refs.refFormObserver.reset()
        })
        this.name = ''
        this.value = ''
        this.isPickerLoaded = false
      },
      pushArrayOfLinks(values) {
        values.forEach(value => {
          this.links.push({
            id: (this.nextTodoId += 1),
            name: value.title,
            value: value.link,
          })
        })
      },
      showDropboxPopup() {
        // ... (existing dropbox logic)
      },
      openPicker() {
        console.log('Opening picker...')
        
        // Check if current token is expired
        if (this.googleToken && this.isTokenExpired()) {
          console.log('Token expired, triggering re-auth...')
          this.addNewAccount()
          return
        }

        if (!this.isPickerLoaded) {
          this.isPickerLoaded = true
        } else {
          this.triggerPickerOpen()
        }
      },
      isTokenExpired(account = null) {
        const time = account ? account.expiresAt : this.expiresAt
        if (!time) return true
        // Add 5 minute buffer (300,000ms)
        return Date.now() > (parseInt(time, 10) - 300000)
      },
      triggerPickerOpen() {
        const el = this.$refs.googlePicker
        if (el) {
          if (typeof el.open === 'function') {
            el.open()
          } else {
            el.visible = true
          }
        }
      },
      onAuthError(event) {
        console.error('Picker Auth Error:', event.detail)
        // If the user closes the popup or an error occurs, we should reset state
        // to prevent loops or hanging components
        this.isPickerLoaded = false
      },
      async onAuthenticated(event) {
        const { access_token, expires_in } = event.detail
        if (access_token) {
          const expiresAt = Date.now() + (parseInt(expires_in, 10) * 1000)
          this.googleToken = access_token
          this.expiresAt = expiresAt
          localStorage.setItem('google_drive_token', access_token)
          localStorage.setItem('google_token_expires_at', expiresAt)

          try {
            const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
              headers: { Authorization: `Bearer ${access_token}` },
            })
            const user = await response.json()
            if (user.email) {
              const account = { 
                email: user.email, 
                token: access_token,
                expiresAt: expiresAt
              }
              this.currentEmail = user.email

              // Update or add to accounts list
              const existingIdx = this.googleAccounts.findIndex(a => a.email === user.email)
              if (existingIdx > -1) {
                this.$set(this.googleAccounts, existingIdx, account)
              } else {
                this.googleAccounts.push(account)
              }

              localStorage.setItem('google_accounts', JSON.stringify(this.googleAccounts))
              localStorage.setItem('google_active_email', user.email)
            }
          } catch (e) {
            console.error('Failed to fetch user info:', e)
          }
        }
      },
      selectAccount(account) {
        if (this.isTokenExpired(account)) {
          console.log('Account token expired, re-authenticating...')
          this.googleToken = null
          this.currentEmail = account.email // Pass as hint if we had login-hint support
          this.isPickerLoaded = false
          this.$nextTick(() => this.openPicker())
          return
        }
        this.googleToken = account.token
        this.currentEmail = account.email
        this.expiresAt = account.expiresAt
        localStorage.setItem('google_drive_token', account.token)
        localStorage.setItem('google_active_email', account.email)
        localStorage.setItem('google_token_expires_at', account.expiresAt)
        this.openPicker()
      },
      addNewAccount() {
        this.googleToken = null
        this.isPickerLoaded = false
        this.$nextTick(() => {
          this.openPicker()
        })
      },
      clearAllAccounts() {
        this.googleAccounts = []
        this.googleToken = null
        this.currentEmail = null
        localStorage.removeItem('google_accounts')
        localStorage.removeItem('google_drive_token')
        localStorage.removeItem('google_active_email')
        localStorage.removeItem('google_token_expires_at')
        this.isPickerLoaded = false
      },
      switchGoogleAccount() {
        this.addNewAccount()
      },
      onDriveFilePicked(event) {
        console.log('Picker Event Detail:', event.detail)
        const { docs, token } = event.detail
        if (token) {
          this.googleToken = token
        }
        if (docs && docs.length > 0) {
          const file = docs[0]
          console.log('Selected File:', file)
          const newRow = {
            id: (this.nextTodoId += 1),
            name: file.name,
            value: file.url || file.embedUrl,
          }
          console.log('Pushing to links:', newRow)
          this.links.push(newRow)
        }
      },
    },
  }
</script>

<style scoped>
  .repeater-form {
    overflow: hidden;
    transition: 0.35s height;
  }
  .logo {
    width: 14px;
    height: 14px;
    margin-right: 3.5px;
  }

  .add-btn {
    margin-right: 15px;
  }

  .btn-google-drive {
    background-color: #fff !important;
    border-color: #d8d6de !important;
    color: #5e5873 !important;
  }

  .btn-google-drive:hover {
    background-color: #f8f8f8 !important;
    color: #5e5873 !important;
  }

  /* Split Button Styling */
  .btn-google-drive ::v-deep .dropdown-toggle-split {
    border-left: 1px solid #d8d6de !important;
  }
</style>

<style>
  /* Ensure Google Picker is above modals and sidebars */
  drive-picker {
    position: relative;
    z-index: 9999 !important;
  }
  .picker-dialog {
    z-index: 9999 !important;
  }
  .picker-dialog-bg {
    z-index: 9998 !important;
  }
</style>
